import config from '../../../config';

const apiV1Url = config.apiUrl();
const baseUrl = `${apiV1Url}/WhatsAppWhitelistProcess`;

export default {
  uploadFile: (): string => `${baseUrl}`,
};
